import "./UserCredentialsTabComponent.scss";
import * as Yup from "yup"
import {Formik, Form, Field, FieldProps, FormikHelpers} from "formik";
import React, {useCallback} from "react";
import FormikInputComponent from "../../../../shared/components/core/formik-input/FormikInputComponent";
import ButtonComponent from "../../../../shared/components/core/button/ButtonComponent";
import {Grid} from "@material-ui/core";
import PasswordValidationComponent from "../../../../shared/components/password-validation/PasswordValidationComponent";
import {CommonService} from "../../../../shared/services";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import {ILoginResponse} from "../../../../shared/models/account.model";
import LottieFileGenarationComponent
    from "../../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import {ImageConfig} from "../../../../constants";
import StatusCardComponent from "../../../../shared/components/status-card/statusCardComponent";
import commonService from "../../../../shared/services/common.service";

interface UserCredentialsTabComponentProps {
    userDetails: any;
    isLoading: boolean;
    isLoaded: boolean;
    isFailed: boolean;
}

const userCredentialsValidationSchema = Yup.object({
    password: Yup.string()
        .min(8, 'Password must be at least 8 characters')
        .max(16, 'Password cannot be more than 16 characters')
        .matches(/[A-Z]/, 'Password must contain at least one upper-case character')
        .matches(/[a-z]/, 'Password must contain at least one lower-case character')
        .matches(/\d/, 'Password must contain at least one digit')
        .matches(/[@$!%*?&#]/, 'Password must contain at least one special character')
        .required('Password is required'),
    confirmPassword: Yup.string().when("password", {
        is: (val: string) => (val && val.length > 0 ? true : false),
        then: Yup.string().required("Confirm Password is required").oneOf(
            [Yup.ref("password")],
            "Both password need to be the same"
        )
    })

})

interface userCredentialsSchema {
    password: string;
    confirmPassword: string;
}

const userCredentialsInitialValues: userCredentialsSchema = {
    password: "",
    confirmPassword: "",
}

const UserCredentialsTabComponent = (props: UserCredentialsTabComponentProps) => {
    const {userDetails, isLoading, isLoaded, isFailed} = props;
    const handleSubmitForm = useCallback((values: any, {setSubmitting, setErrors}: FormikHelpers<any>) => {
        const payload = {
            emailId: userDetails.emailId,
            newPassword: values?.confirmPassword
        }
        setSubmitting(true);
        // return;
        CommonService._user.updateUserPassword(payload)
            .then((response: IAPIResponseType<ILoginResponse>) => {
                setSubmitting(false);
                commonService._alert.showToast("Password updated successfully", "success")
            })
            .catch((error: any) => {
                CommonService.handleErrors(setErrors, error);
                commonService._alert.showToast(error.message || "Error updating password", "error")
                setSubmitting(false);
            })
    }, [userDetails])
    return (
        <div className={'user-credentials-tab-component'}>
            {
                isLoading && <div className="h-v-center">
                    <LottieFileGenarationComponent
                        loop={true}
                        autoplay={true}
                        animationData={ImageConfig.LoadingLottieFile}/>
                </div>
            }
            {
                isFailed && <>
                    <StatusCardComponent title={"User details failed to load"}/>
                </>
            }
            {

            }
            {/*<div className="set-new-password-title auth-form-title">*/}
            {/*    Set New Password Behalf of User*/}
            {/*</div>*/}
            {/*<div className={'set-new-password-description auth-form-description'}>*/}
            {/*    Your new password must be different to previously user passwords.*/}
            {/*</div>*/}
            {
                isLoaded && <Formik
                    initialValues={userCredentialsInitialValues}
                    validationSchema={userCredentialsValidationSchema}
                    validateOnBlur={true}
                    validateOnChange={true}
                    onSubmit={handleSubmitForm}>
                    {({values, isSubmitting, validateForm, setFieldError, isValid, setErrors, errors}) => {
                        return <Form className={"t-form"} noValidate>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                    <div className="t-form-controls pdd-top-10">
                                        <Field name={'password'}>
                                            {
                                                (field: FieldProps) => (
                                                    <div className="mrg-bottom-25">
                                                        <FormikInputComponent
                                                            label={'Password'}
                                                            placeholder={'Enter New Password'}
                                                            type={'password'}
                                                            toggleShowPassword={true}
                                                            maxLength={16}
                                                            required={true}
                                                            formikField={field}
                                                        />
                                                    </div>
                                                )
                                            }
                                        </Field>
                                        <Field name={'confirmPassword'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikInputComponent
                                                        label={'Password'}
                                                        placeholder={'Confirm New Password'}
                                                        type={'password'}
                                                        maxLength={16}
                                                        required={true}
                                                        toggleShowPassword={true}
                                                        // disabled={!validPassword}
                                                        formikField={field}
                                                    />
                                                )
                                            }
                                        </Field>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                    {/*<PasswordStrengthCheckerComponent password={values.password}*/}
                                    {/*                                  isPasswordValid={(isValid: boolean) => {*/}
                                    {/*                                      setValidPassword(isValid);*/}
                                    {/*                                  }}/>*/}
                                    <PasswordValidationComponent password={values.password}/>
                                </Grid>
                            </Grid>
                            <div className="t-form-actions form-action-section-edit">
                                <ButtonComponent
                                    type={"submit"}
                                    size={"large"}
                                    isLoading={isSubmitting}
                                    className={"mrg-top-40 width-25"}
                                    disabled={!isValid}
                                >
                                    Update Password
                                </ButtonComponent>
                            </div>
                        </Form>
                    }}
                </Formik>
            }
        </div>
    );

};

export default UserCredentialsTabComponent;
